/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InlineEditTextInputDirective {
    public restrict = 'E';
    public scope;
    public template;

    public currentValue;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            label: '@?',
            canEdit: '=?'
        };

        this.template = `  
            <md-input-container class="d-flex m-0 p-0">                
                <input ng-model="value" ng-click="edit()" aria-label="label" ng-blur="doneEdit()" ng-keyup="$event.keyCode == 13 ? doneEdit() : null", ng-disabled="canEdit == false">
            </md-input-container>
        `;
    }


    public link($scope: any, $element: any, attrs: any): any {
        // check if url does not start with http(s) - if it does append it
        // this is to ensure the link opens correctly in a new tab if its an external link
        $scope.empEdit = {
            canEdit: $scope.canEdit
        };

        if ($scope.value === '---') {
            $scope.value = "";
        }
        var inputElement: any = $($element).find(':input')[0];
        // $element.addClass('inline-edit-text');
        // $scope.editing = false;


        $scope.edit = function (): any {
            // $scope.editing = true;
            this.currentValue = $scope.value;
            if ($scope.value === '---') {
                $scope.value = '';
            }
            // $element.addClass('active');
            // $element.addClass('');
            inputElement.focus();
        };

        $scope.doneEdit = function (): any {
            // $scope.editing = false;
            var newValue: any = $scope.value;

            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
        };

        $scope.undo = function (): any {
            $element.removeClass('active');
            $scope.value = this.currentValue;
        };
    }

    public static DirectiveFn($timeout: any): InlineEditTextInputDirective {
        return new InlineEditTextInputDirective($timeout);
    }
}

InlineEditTextInputDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditTextInput', InlineEditTextInputDirective.DirectiveFn);





// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_text_input.directive.ts